import {FC, useEffect, useMemo} from 'react'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../../../../_metronic/helpers'
import { DLMSiteApplication, DLM_USER_INSPECTION_RESPOND_STATES, useDLMLabellingListContext, claimDLMSiteInspection, getLastPathFromWorkflow } from '../../../../../core/doclabel'
import { useAuth } from '../../../../../auth'
import { useQueryClient, useMutation } from 'react-query'
import { findIndex } from 'lodash'

const REASSIGN_LABEL_STATES = [    
  { state: 'Site Labelling Setup', role: 'DLM Admin'},
  { state: 'Site Labelling', role: 'DLM Inspector'},
  { state: 'Site Labelling Approved', role: 'DLM Admin'},
  { state: 'Applicant Signed', role: 'DLM Admin'},
  { state: 'ROI Pending SCDF Verification', role: 'DLM Admin'},
];

type Props = {
  site: DLMSiteApplication
}

const DLMLabellingUserActionsCell: FC<Props> = ({site}) => {
    
  const { setCurrentSite, workflow, setItemIDForDelete, setObjectOption1 } = useDLMLabellingListContext();
  const { hasRole, currentUser} = useAuth();

  const queryClient = useQueryClient();

  const { id, canRespond, responseTitle, canClaim, appID, isTerminating, canReassign, assignRole, assignedId } = useMemo(() => {
      
    if (! (site && currentUser) ) return { id: 0, canRespond : false, responseTitle: '', canClaim: false, appID : 0, canReassign: false, assignRole: '', assignedId : 0};
    let responseTitle = "";

    const { id, state, assignedTo, dlmApplication } = site;
    const { id: appID } = dlmApplication;

    const isAssigned = (currentUser && assignedTo && currentUser.id === assignedTo.id) ? true : false;
    const assignedId = (assignedTo && assignedTo?.id && assignedTo.id > 0) ? assignedTo.id : 0;
    const canRespond = (state && DLM_USER_INSPECTION_RESPOND_STATES.indexOf(site.state) > -1);

    const canClaim = (state !== 'Site Labelling') && canRespond && (! isAssigned) && hasRole('DLM Admin');

    if (canRespond && isAssigned) {
      switch (state) {
        case 'Site Labelling Setup':
          responseTitle = 'Setup Site Labelling';
          break;
        case 'Site Inspection':
          responseTitle = 'Submit Inspection';
          break;
        case 'ROI Pending SCDF Verification':
          responseTitle = 'Finalize ROI';
          break;
        case 'Applicant Signed': 
          responseTitle = 'Check ROI';
          break;
        default:
          responseTitle = 'Respond'; 
          break;
      }    
    }

    const isTerminating = (hasRole('DLM Admin') && 
      (site.requestTerminateState && site.requestTerminateState === 'REQUEST_TERMINATE_APPLICATION')
    );  

    const reassignIdx = findIndex(REASSIGN_LABEL_STATES, { state });     
    const assignRole = reassignIdx > -1 ? REASSIGN_LABEL_STATES[reassignIdx].role : '';
    const canReassign = (hasRole('DLM Admin') && reassignIdx > -1);

    return { id, canRespond, responseTitle, canClaim, appID, isTerminating, canReassign, assignRole, assignedId };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site, currentUser]);


  //@ts-ignore
  const claimSiteInspection = useMutation(() => claimDLMSiteInspection(id, currentUser.id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath: getLastPathFromWorkflow(workflow) }])
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
    },
  })

  useEffect(() => {
    if (canRespond || canClaim || isTerminating) {
      MenuComponent.reinitialization();
    }
  }, [canRespond, canClaim, isTerminating])

  if (! (canRespond || canClaim || isTerminating)) {
    return null;
  }

  return (
  <div className="align-top">
    <div      
      className='btn btn-light btn-active-light-primary btn-sm'
      data-kt-menu-trigger='click'
      data-kt-menu-attach='parent'
      data-kt-menu-placement='bottom-start'
    >
      Actions
      <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
    </div>      
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 py-4 mw-150px'
      data-kt-menu='true'
    >        
      { canClaim && 
      <div className='menu-item px-3' title="Claim Application">
        <div className='menu-link px-3' onClick={ async () => { await claimSiteInspection.mutateAsync()}} >
          Claim
        </div>
      </div>
      }
      { responseTitle && 
      <div className='menu-item px-3'>
        <div className='menu-link px-3' onClick={() => { setCurrentSite(site) }}>
          {responseTitle}
        </div>
      </div>  
      }    
      { (canReassign && setObjectOption1) &&
      <div className='menu-item px-3 text-start' title="Reassign Application">
        <div
          className='menu-link px-3' 
          onClick={() => setObjectOption1({
            siteApplicationid: id,
            assignRole, 
            assignedId
          })}
        >
          Reassign
        </div>
      </div>
      }
      { isTerminating &&
      <div className='menu-item px-3' title="Process Termination">
        <div className='menu-link px-3' onClick={ () => setItemIDForDelete(id)} >
          Process Termination
        </div>
      </div>
      }                          
    </div>    
  </div>
  )
}

export {DLMLabellingUserActionsCell}
